// session components
const Roles = () => import('@/views/users_permission/Roles')

const menuUsersPermission = [
  {
    path: '/admin/permission/roles',
    component: Roles,
    meta: {
      title: 'User Permission'
    }
  }
]

const routerUserPermission = menuUsersPermission.map(data => {
  const { path, title, component, children } = data

  return {
    path: path,
    name: title,
    component: component,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})

export default routerUserPermission
